"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRenderCellViews = useRenderCellViews;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_2 = require("@heroui/react");
var utils_1 = require("@doshexchnage/utils");
var StatusCell = function (_a) {
    var challenge = _a.challenge;
    if (challenge.is_complete) {
        return ((0, jsx_runtime_1.jsx)(react_2.Chip, { className: "text-nowrap text-xs capitalize", color: "success", size: "sm", variant: "soft", children: "Completed" }));
    }
    if (challenge.status === "active") {
        return ((0, jsx_runtime_1.jsx)(react_2.Chip, { className: "text-nowrap text-xs capitalize", color: "accent", size: "sm", variant: "soft", children: "Active" }));
    }
    return ((0, jsx_runtime_1.jsx)(react_2.Chip, { className: "text-nowrap text-xs capitalize", color: "default", size: "sm", variant: "soft", children: challenge.status || "Unknown" }));
};
var ProgressCell = function (_a) {
    var challenge = _a.challenge;
    if (challenge.progress === undefined || challenge.progress === null) {
        return (0, jsx_runtime_1.jsx)("div", { className: "text-sm text-muted", children: "\u2014" });
    }
    var progressValue = Math.round(challenge.progress);
    var color = challenge.is_complete ? "success" : "accent";
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-2 min-w-[120px]", children: [(0, jsx_runtime_1.jsx)(react_2.ProgressBar, { value: progressValue, color: color, size: "sm", className: "flex-grow", children: (0, jsx_runtime_1.jsx)(react_2.ProgressBar.Track, { children: (0, jsx_runtime_1.jsx)(react_2.ProgressBar.Fill, {}) }) }), (0, jsx_runtime_1.jsxs)("span", { className: "text-sm text-default-foreground min-w-[40px]", children: [progressValue, "%"] })] }));
};
var DatesCell = function (_a) {
    var challenge = _a.challenge;
    if (!challenge.schedule) {
        return (0, jsx_runtime_1.jsx)("div", { className: "text-sm text-muted", children: "\u2014" });
    }
    var startDate = challenge.schedule.start_date ? utils_1.Formatting.formatDateTime(new Date(challenge.schedule.start_date), "yyyy-MM-dd") : "—";
    var endDate = challenge.schedule.end_date ? utils_1.Formatting.formatDateTime(new Date(challenge.schedule.end_date), "yyyy-MM-dd") : "—";
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col text-xs text-default-foreground", children: [(0, jsx_runtime_1.jsx)("span", { children: startDate }), (0, jsx_runtime_1.jsx)("span", { className: "text-muted", children: "to" }), (0, jsx_runtime_1.jsx)("span", { children: endDate })] }));
};
var ObjectivesCell = function (_a) {
    var _b;
    var challenge = _a.challenge;
    var count = ((_b = challenge.objectives) === null || _b === void 0 ? void 0 : _b.length) || 0;
    return ((0, jsx_runtime_1.jsxs)("div", { className: "text-sm text-default-foreground", children: [count, " ", count === 1 ? "objective" : "objectives"] }));
};
function useRenderCellViews() {
    var renderCellViews = (0, react_1.useCallback)(function (challenge) {
        return [
            { key: "title", content: (0, jsx_runtime_1.jsx)("div", { className: "text-sm font-semibold text-default-foreground", children: challenge.title }) },
            { key: "description", content: (0, jsx_runtime_1.jsx)("div", { className: "text-sm text-muted max-w-md line-clamp-2", children: challenge.description || "—" }) },
            { key: "status", content: (0, jsx_runtime_1.jsx)(StatusCell, { challenge: challenge }) },
            { key: "progress", content: (0, jsx_runtime_1.jsx)(ProgressCell, { challenge: challenge }) },
            { key: "dates", content: (0, jsx_runtime_1.jsx)(DatesCell, { challenge: challenge }) },
            { key: "objectives", content: (0, jsx_runtime_1.jsx)(ObjectivesCell, { challenge: challenge }) },
        ];
    }, []);
    return (0, react_1.useMemo)(function () { return ({
        renderCellViews: renderCellViews,
    }); }, [renderCellViews]);
}
